export const LOADING = 'branch/LOADING';
export const MESSAGE = 'branch/MESSAGE';
export const SET_BRANCHES = 'branch/SET_BRANCHES';
export const SET_BRANCH = 'branch/SET_BRANCH';
export const SET_WAREHOUSES = 'branch/SET_WAREHOUSES';